import React from "react";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import { WeaSelect } from "ecCom";

@observer
export default class BrowserItem extends React.PureComponent {
  onChange = (...args) => {
    const { bindObj, itemKey, onChange } = this.props;
    bindObj.onChange(...args);
    if (typeof onChange === "function") {
      onChange(itemKey, args);
    }
  };
  render() {
    const { bindObj, c } = this.props;
    return (
      <WeaSelect
        ecId={`${this.props.ecId}_WeaSelect@3vudrr`}
        {...bindObj.bind()}
        onChange={this.onChange}
        {...toJS(c)}
        {...toJS(c.otherParams)}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./comMobx/wea-switch/components/SelectItem.js